
import { defineComponent, PropType } from 'vue'
import { iDocument } from '@/modules/documentExecution/documentDetails/DocumentDetails'
import { AxiosResponse } from 'axios'
import { filterDefault } from '@/helpers/commons/filterHelper'
import mainDescriptor from '@/modules/documentExecution/documentDetails/DocumentDetailsDescriptor.json'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InlineMessage from 'primevue/inlinemessage'

export default defineComponent({
    name: 'data-lineage',
    components: {
        DataTable,
        Column,
        InlineMessage
    },
    props: { selectedDocument: { type: Object as PropType<iDocument>, required: true }, allDocumentDetailsProp: { type: Array as any, required: true } },
    emits: [],
    data() {
        return {
            mainDescriptor,
            savedSubreports: [] as any,
            selectedSubreports: [] as any[],
            loading: false,
            filters: { global: [filterDefault] } as Object,
            globalFilterFields: ['name']
        }
    },
    async created() {
        await this.getSelectedSubreports()
    },
    watch: {
        async allDocumentDetailsProp() {
            await this.getSelectedSubreports()
        }
    },

    methods: {
        async getSelectedSubreports() {
            this.loading = true
            if (this.selectedDocument?.id) {
                await this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/documentdetails/${this.selectedDocument?.id}/subreports`).then((response: AxiosResponse<any>) => (this.savedSubreports = response.data))
                this.setCheckedTables()
            }
            this.loading = false
        },
        setCheckedTables() {
            for (var i = 0; i < this.allDocumentDetailsProp.length; i++) {
                for (var j = 0; j < this.savedSubreports.length; j++) {
                    if (this.allDocumentDetailsProp[i].id == this.savedSubreports[j].sub_rpt_id) {
                        this.selectedSubreports.push(this.allDocumentDetailsProp[i])
                    }
                }
            }
        },
        peristTable(event) {
            const postData = event.data
            delete postData.dataSetLabel
            delete postData.creationDate
            postData.refreshSeconds = parseInt(postData.refreshSeconds)
            this.$http
                .post(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/documentdetails/${this.selectedDocument.id}/subreports`, postData, {
                    headers: { 'X-Disable-Errors': 'true' }
                })
                .then(() => this.$store.commit('setInfo', { title: this.$t('common.save'), msg: this.$t('documentExecution.documentDetails.subreports.persistOk') }))
                .catch(() => this.$store.commit('setError', { title: this.$t('common.toast.errorTitle'), msg: this.$t('documentExecution.documentDetails.subreports.persistError') }))
        },
        deleteTable(event) {
            this.$http
                .delete(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/documentdetails/${this.selectedDocument.id}/subreports/${event.data.id}`, {
                    headers: { 'X-Disable-Errors': 'true' }
                })
                .then(() => this.$store.commit('setInfo', { title: this.$t('common.save'), msg: this.$t('documentExecution.documentDetails.subreports.deleteOk') }))
                .catch(() => this.$store.commit('setError', { title: this.$t('common.toast.errorTitle'), msg: this.$t('documentExecution.documentDetails.subreports.deleteError') }))
        }
    }
})
